declare const WEBFLOW_DEFAULT_HOST: string | undefined;
// wfenvironment is rendered on the page by the server with environment specific variables.
declare type WfEnvironmentType = {
  [key: string]: boolean | string | undefined | null | number;
};

// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | { document: any; navigator: any; wfenvironment: any; }'. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
const {
  wfenvironment: WF_ENVIRONMENT,
}: Window & typeof globalThis & {wfenvironment: WfEnvironmentType} =
  typeof window !== 'undefined' ? window : {};

export const webflowDefaultHost: string = (function () {
  // This file is loaded on the server via builds so window may be
  // undefined as well
  if (
    typeof WF_ENVIRONMENT !== 'undefined' &&
    'WEBFLOW_DEFAULT_HOST' in WF_ENVIRONMENT
  ) {
    return typeof WF_ENVIRONMENT.WEBFLOW_DEFAULT_HOST === 'string'
      ? WF_ENVIRONMENT.WEBFLOW_DEFAULT_HOST
      : '';
  }
  // legacy fallback where values baked into the bundle by env-injections
  if (typeof WEBFLOW_DEFAULT_HOST !== 'undefined') {
    return typeof WEBFLOW_DEFAULT_HOST === 'string' ? WEBFLOW_DEFAULT_HOST : '';
  }
  return '';
})();
